export default __webpack_public_path__ + "static/media/home-digital-agency-img-11.6d6040fb.jpg";